export default "__VITE_ASSET__Bn7Q$Wpe__"